import { getCsoEvent } from '@atomic-utils/time'

export interface CoinGeckoResponse {
  bitcoin: {
    usd: number;
    cad: number;
  };
}

export interface TVLData {
  btc: number;
  usd: number;
  cad: number;
}

export const getTVL = async (): Promise<TVLData> => {
  const proxyUrl = "https://cors.atomic.finance/";
  const urls = {
    oysterStrategy: proxyUrl + "https://strategy.atomic.finance/api/v1/oyster/state",
    engineStrategy: proxyUrl + "https://strategy.atomic.finance/api/v1/engine/state",
    oysterOffer: proxyUrl + "https://mm.atomic.finance/api/v0/irc/offer/A05cb9t6qWxhVayv/oyster/latest",
    engineOffer: proxyUrl + "https://mm.atomic.finance/api/v0/irc/offer/A05cb9t6qWxhVayv/engine/latest",
    deribit: "https://www.deribit.com/api/v2/public/get_index_price?index_name=btc_usd"
  };

  const [
    oysterStrategyData,
    engineStrategyData,
    oysterOfferData,
    engineOfferData,
    deribitData
  ] = await Promise.all([
    fetch(urls.oysterStrategy).then(res => res.json()),
    fetch(urls.engineStrategy).then(res => res.json()),
    fetch(urls.oysterOffer).then(res => res.json()),
    fetch(urls.engineOffer).then(res => res.json()),
    fetch(urls.deribit).then(res => res.json())
  ]);

  const oysterMaxCapacity = parseFloat(oysterStrategyData.max_capacity);
  const engineMaxCapacity = parseFloat(engineStrategyData.max_capacity);

  const currentEvent = getCsoEvent(new Date('2024-09-28T00:00:00Z'));
  const eventsToReturnMaxCapacity = ['dlcExpiry', 'dlcAttestation', 'rolloverOpen', 'newEntryOpen', 'newEntryClosed'];

  if (eventsToReturnMaxCapacity.includes(currentEvent)) {
    const totalMaxCapacity = (oysterMaxCapacity + engineMaxCapacity) / 1e8;
    const TVL_USD = totalMaxCapacity * deribitData.result.index_price;
    return { btc: totalMaxCapacity, usd: TVL_USD, cad: 0 };
  }

  const totalCollateralOyster = oysterOfferData.contractInfo.totalCollateral;
  const totalCollateralEngine = engineOfferData.contractInfo.totalCollateral;

  const TVL_BTC_Oyster = (oysterMaxCapacity - totalCollateralOyster) / 1e8;
  const TVL_BTC_Engine = (engineMaxCapacity - totalCollateralEngine) / 1e8;

  const TVL_BTC = TVL_BTC_Oyster + TVL_BTC_Engine;
  const TVL_USD = TVL_BTC * deribitData.result.index_price;

  return { btc: TVL_BTC, usd: TVL_USD, cad: 0 };
};
